import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: 'home' },

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'home' },

    // Auth routes for guests
    {
        path: '',
        loadComponent: () =>
            import('app/layout/layout.component').then(
                (m) => m.LayoutComponent
            ),
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'confirmation-required',
                loadChildren: () =>
                    import(
                        'app/modules/auth/confirmation-required/confirmation-required.routes'
                    ),
            },
            {
                path: 'forgot-password',
                loadChildren: () =>
                    import(
                        'app/modules/auth/forgot-password/forgot-password.routes'
                    ),
            },
            {
                path: 'sign-in',
                loadChildren: () =>
                    import('app/modules/auth/sign-in/sign-in.routes'),
            },
        ],
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        loadComponent: () =>
            import('app/layout/layout.component').then(
                (m) => m.LayoutComponent
            ),
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'sign-out',
                loadChildren: () =>
                    import('app/modules/auth/sign-out/sign-out.routes'),
            },
            {
                path: 'reset-password',
                loadChildren: () =>
                    import(
                        'app/modules/auth/reset-password/reset-password.routes'
                    ),
            },
            //{path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes')}
        ],
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        loadComponent: () =>
            import('app/layout/layout.component').then(
                (m) => m.LayoutComponent
            ),
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            {
                path: 'home',
                loadChildren: () => import('app/modules/home/home.routes'),
            },
            {
                path: 'data-settings/models',
                loadChildren: () =>
                    import('app/modules/modelling/modeling.routes'),
            },
            {
                path: 'data-management/ingestions',
                loadChildren: () =>
                    import('app/modules/data-ingestion/data-ingestion.routes'),
            },
            {
                path: 'data-management/datasets',
                loadChildren: () =>
                    import('app/modules/data-set/data-set.routes'),
            },
            {
                path: 'data-management/playground',
                loadChildren: () =>
                    import('app/modules/playground/playground.routes'),
            },
            {
                path: 'data-management/dashboard-builder',
                loadChildren: () =>
                    import(
                        'app/modules/dashboard-builder/dashboard-builder.routes'
                    ),
            },
            {
                path: 'data-management/dashboards',
                loadChildren: () =>
                    import('app/modules/dashboard/dashboard.routes'),
            },
            {
                path: 'data-management/graphic-templates',
                loadChildren: () =>
                    import(
                        'app/modules/graphic-template/graphic-template.routes'
                    ),
            },
            {
                path: 'data-management/documents',
                loadChildren: () =>
                    import('app/modules/document/document.routes'),
            },
            {
                path: 'user-management/users',
                loadChildren: () => import('app/modules/user/user.routes'),
            },
            {
                path: 'parameters/companies',
                loadChildren: () =>
                    import('app/modules/company/company.routes'),
            },
            {
                path: 'parameters/company-domains',
                loadChildren: () =>
                    import('app/modules/company-domain/company-domain.routes'),
            },
            {
                path: 'parameters',
                loadChildren: () =>
                    import('app/modules/parameter/parameter.routes'),
            },
            {
                path: 'user-management/companies',
                loadChildren: () =>
                    import('app/modules/company/company.routes'),
            },
            {
                path: 'subscriptions',
                loadChildren: () =>
                    import('app/modules/subscription/subscription.route'),
            },
            {
                path: 'parameters/localities',
                loadChildren: () =>
                    import('app/modules/country/country.routes'),
            },
        ],
    },
];
